<template>
  <div
    style="min-width: 400px; max-height: 350px; overflow-y: auto"
    class="flex-1 max-w-[500px] p-4 border rounded-lg shadow bg-white"
  >
    <h2 class="mb-4 text-lg font-semibold">
      {{ title }}
    </h2>

    <table class="w-full text-sm">
      <tbody class="text-gray-800">
        <template v-for="(row, index) in rows">
          <tr
            v-if="row.userName"
            :key="`${row.userName}-${index}`"
            class="border-t border-gray-300 bg-gray-50"
          >
            <td
              colspan="2"
              class="py-2 font-semibold text-gray-700"
            >
              {{ row.userName }}
            </td>
          </tr>

          <tr
            :key="`${row.label}-${index}`"
            class="border-t border-gray-200"
          >
            <td class="py-2">
              {{ row.label }}
            </td>

            <td class="text-right font-medium">
              <span
                :class="row.connected ? 'text-green-600' : 'text-gray-500'"
              >
                {{ row.value }}
              </span>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    }
  }
}
</script>
